import {Injectable} from '@angular/core';
import {GenericRoteirizadorService} from '../../../core/services/generic-roteirizador.service';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';
import {ParametroModel} from '../components/configuracoes/parametros/parametro.model';
import {PosicaoPedidoComboModel} from '../components/configuracoes/parametros/parametros-portal/model/posicao-pedido-combo-model';
import {Observable} from 'rxjs';
import {enumTipoParametro} from '../enums/enums';

@Injectable({providedIn: 'root'})
export class ParametroPortalService extends GenericRoteirizadorService {

  constructor(
    private mensagensService: MensagensService,
    private httpClient: HttpClient) {
    super();
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }

  getUrlRecurso(): string {
    return '/parametrosRot';
  }

  listarParametrosPortal() {
    return this.get<any[]>('/listarParametrosPortal');
  }

  salvarParametros(parametroModel: ParametroModel) {
    return this.post<ParametroModel>('/salvar', {dados: parametroModel});
  }

  obterParametroPerfilRoteirizacao() {
    return this.get<ParametroModel>('/perfilRoteirizacao');
  }

  obterParametroPeriodoInicialFinal() {
    return this.get<ParametroModel>('/periodoEntrega');
  }

  obterParametroTrabalharComImportacaoXMl() {
    return this.get<ParametroModel>('/importacaoXML');
  }

  obterParametroHabilitarEdicaoPedidoCarregamento() {
    return this.get<ParametroModel>('/habilitarEdicaoPedidoCarregamento');
  }

  obterParametroDataEntregaDiaAtual() {
    return this.get<ParametroModel>('/dataEntregaDiaAtual');
  }

  obterParametroVeiculoMotoristaOpcional() {
    return this.get<ParametroModel>('/listarParametrosPortalOpcional');
  }

  obterParametroEspecifico(parametro: Object) {
    return this.post<ParametroModel>('/buscarParametro', {dados: parametro, enviarComoQueryString: true});
  }

  listarTiposRomaneio() {
    return this.get<any[]>('/listarTiposRomaneio');
  }

  listarFiltrosExibicaoValorPedidos() {
    return this.get<any[]>('/listarFiltrosExibicaoValorPedidos');
  }

  listarPosicoesPedidosCombo(): Observable<PosicaoPedidoComboModel[]> {
    return this.get<PosicaoPedidoComboModel[]>('/listarPosicoesPedidoCombo');
  }

  listarParametrosPortalPersonalizado(filtro: any) {
    return this.post<ParametroModel[]>(`/listarParametrosPortalPersonalizado`, {
      dados: filtro
    });
  }

  listarParametrosTipoPortal(tipoParametro: string = enumTipoParametro.GERAL) {
    return this.get<ParametroModel[]>(`/listar-parametros-portal/${tipoParametro}`);
  }

  atualizarTipoParametro(parametroTipoAtualizar: any) {
    return this.post<ParametroModel[]>(`/atualizarTipoParametro`, {
      dados: parametroTipoAtualizar
    });
  }

  obterParametroPermitirAlterarRomaneioIniciado() {
    return this.get<boolean>(`/buscarParametroPermitirEdicaoRomaneioIniciado`);
  }

  obterListaParametros(id: string[]) {
    return this.post<ParametroModel[]>('/buscarListaParametrosGeralFilalUsuario', {dados: id, enviarComoQueryString: false});
  }

  getTrabalhaComImportacaoExcel() {
    return this.get<boolean>('/trabalhaImportacaoExcel');
  }


  getQuantidadeDiasParametroAgendamento(): Observable<number> {
    return this.get<number>('/quantidadeDiasParametroAgendamento');
  }
}
